import React from 'react'
import styled from 'styled-components'

interface TextProps {
  text: string
  fontSize?: string
  fontWeight?: string
  color?: string
  margin?: string
  maxWidth?: string
  role?: string
  'aria-level'?: number
  isResponsive?: boolean
  lineHeight?: string
}

const StyledText = styled.p<{
  $fontSize?: string
  $fontWeight?: string
  $color?: string
  $margin?: string
  $maxWidth?: string
  $isResponsive?: boolean
  $lineHeight?: string
}>`
  font-size: ${(props) => props.$fontSize || '1rem'};
  font-weight: ${(props) => props.$fontWeight || 'normal'};
  color: ${(props) => props.$color || '#ffffff'};
  margin: ${(props) => props.$margin || '0'};
  max-width: ${(props) => props.$maxWidth || 'none'};
  line-height: ${(props) => props.$lineHeight || '1.5'};

  ${(props) =>
    props.$isResponsive &&
    `
    @media (max-width: 768px) {
      font-size: calc(${props.$fontSize || '1rem'} * 0.9);
    }
  `}
`

export const Text: React.FC<TextProps> = ({
  text,
  fontSize,
  fontWeight,
  color,
  margin,
  maxWidth,
  role,
  'aria-level': ariaLevel,
  isResponsive = false,
  lineHeight,
}) => {
  return (
    <StyledText
      $fontSize={fontSize}
      $fontWeight={fontWeight}
      $color={color}
      $margin={margin}
      $maxWidth={maxWidth}
      $isResponsive={isResponsive}
      $lineHeight={lineHeight}
      role={role}
      aria-level={ariaLevel}>
      {text}
    </StyledText>
  )
}
